<ag-grid-angular
	style="height: 220px; width: 100%"
	class="ag-theme-alpine"
	[gridOptions]="this.gridOptions"
>
</ag-grid-angular>
